const range = (from: number, to: number) =>
  Array.from({ length: to - from + 1 }, (_, index) => String(from + index));

export const selectOptions = {
  hours: range(0, 24),
  minutes: range(0, 60),
  rates: ['0', '0.25', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4'],
  hours_type: [
    {
      value: 'paid-hours',
      name: 'Paid',
    },
    {
      value: 'clocked-in-hours',
      name: 'Clocked',
    },
  ],
};

export const mapperTranslation = {
  'paid-hours': 'Paid',
  'clocked-in-hours': 'Clocked',
};

export const mapperRulesNames = {
  FULL_WORK_DAY_BONUSES: 'Full Work Day Bonus',
  NO_PAID_BREAKS_FOR_NON_FULL_SHIFTS: 'No Paid Breaks For Non Full Shifts',
};
